export default __webpack_public_path__ + "static/media/caraml.dae2ccfb.png";